import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './MojeDokumenty.css';
import {
  Button,
  Col,
  Collapse,
  Modal,
  OverlayTrigger,
  PageHeader,
  Pagination,
  Row,
  Table,
  Tooltip
  } from 'react-bootstrap';
import fetch from '../../core/fetch';
import waiting from './waiting-wheel-300x300.gif';
import GrayPanel from '../../components/GrayPanel';
import DatePicker from 'react-bootstrap-date-picker';
import Link from '../../components/Link';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../components/utils/utils';
import { freeSharingReasonOptions } from '../eservices/UdostepnienieMaterialow.js'

const mappedKeys = {
  shortName: 'Nazwa',
  timeStart: 'Początek',
  timeEnd: 'Koniec',
  jobId: 'Id zadania',
  userType: 'Typ',
  docReason: '',
  status: 'Status',
  paymentStatus: 'Status płatności',
  teryt: 'Urząd',
  wniosekFileName: 'Nazwa wniosku',
  motionSendDate: 'Data złożenia wniosku',
  fk_userID: 'ID użytkownika',
};

const buttonPayStyle = {
  padding: '2px 2px',
  marginLeft: '0px',
};

const polishMonthLabels = [
  'Styczeń',
  'Luty',
  'Marzec',
  'Kwiecień',
  'Maj',
  'Czerwiec',
  'Lipiec',
  'Sierpień',
  'Wrzesień',
  'Październik',
  'Listopad',
  'Grudzień',
];
const polishDayLabels = ['Niedz', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'So'];

const eServicesInPolish = {
  waiting: 'oczekuje',
  success: 'zapłacono',
};

const operator_map = {
  Przed: 'lt',
  Po: 'gt',
  Równe: 'equal',
};

const col_header_map = {
  idWniosku: 'Numer',
  timeStart: 'Data rozpoczęcia',
  timeEnd: 'Data zakończenia',
  isSigned: 'Status PZ',
  paymentMethod: 'Sposób płatności',
  wysokoscOplaty: 'Kwota brutto',
  paymentStatus: 'Status płatności',
  deliveryMethod: 'Sposób odbioru',
  status: 'Status sprawy',
  actions: 'Dokumenty',
};

const orderingOptions = [
  {
    label: 'Data rozpoczęcia - od najnowszej',
    value: 'start_date desc',
  },
  {
    label: 'Data rozpoczęcia - od najstarszej',
    value: 'start_date',
  },
  {
    label: 'Data zakończenia - od najnowszej',
    value: 'end_date desc',
  },
  {
    label: 'Data zakończenia - od najstarszej',
    value: 'end_date',
  },
  {
    label: 'Numer - rosnąco',
    value: 'idWniosku'
  },
  {
    label: 'Numer - malejąco',
    value: 'idWniosku desc'
  }
];

const MAP_CLAIM_STATUS = {
  'anulowany przez wnioskodawcę': 'niewymagana',
  'anulowany, brak uprawnień': 'niewymagana',
  'roboczy': 'obliczanie opłaty',
  'obliczanie opłaty za wysyłkę': 'obliczanie opłaty',
  'weryfikacja uprawnień': 'obliczanie opłaty',
  'do opłacenia': 'do opłacenia',
  'opłacono, do przygotowania': 'opłacono',
  'opłacono, przygotowano': 'opłacono',
  'bezpłatny, przygotowano': 'niewymagana',
  'wysłano pocztą tradycyjną': 'opłacono',
  'zrealizowano': 'opłacono'
}

class MojeDokumenty extends React.Component {
  state = {
    apply_button_disabled: true,
    per_page: 25,
    docs_page_counter: 25,
    page: 1,
    info_request: null,
    filters: null,
    filtersCollapse: false,
    filtersLabels: [
      'Zastosuj filtry, aby wyszukać sprawę',  // 0: filtersCollapse == false
      'Ukryj filtry'  // 1: filtersCollapse == true
    ],
    date: null,
    format: 'YYYY-MM-DD',
    inputFormat: 'DD/MM/YYYY',
    mode: 'date',
    focused: true,
    operator: 'lt',
    status: '',
    paymentStatus: '',
    searchText: '',
    selected_services: [],
    services_options: [],
    selected_districts: [],
    districts_options: [],
    pages: null,
    user_claims: null,
    visible_columns: [
      'idWniosku',
      'timeStart',
      'timeEnd',
      'isSigned',
      'paymentMethod',
      'wysokoscOplaty',
      'paymentStatus',
      'deliveryMethod',
      'status',
      'actions',
    ],
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
    orderingOption: 'idWniosku',
    orderingCollapse: false,
    orderingLabels: [
      'Sortuj według...',  // 0: orderingCollapse == false
      'Ukryj opcje sortowania'  // 1: orderingCollapse == true
    ],
    paymentMethods: [],
    cancelClaimModal: {
      claimId: null,
      show: false,
    },
    documentsDownloadLink: '#',
    fetchInfoPageTimeout: 0,
    fetchingInfoPage: false,
  };

  dateFormat = 'pl-PL';

  formatDate = dt => {
    if (dt) {
      const data = new Date(dt);
      return data.toLocaleString(this.dateFormat);
    }
    return '';
  };

  componentDidMount() {
    let options = [];
    const urzedy = [];
    for (const v of Object.keys(this.props.districts)) {
      const elem = { label: this.props.districts[v].name, value: this.props.districts[v].teryt };
      urzedy.push(elem);
    }

    const url = `${process.env.API_URL}/eservices/allservices/`;
    fetch(url)
      .then(r => r.json())
      .then(resp => {
        options = resp;
        const ESERVICE_DETAILS = {
          'UdostepnienieMaterialow': ' (E‑Usługa)',
          'UdostepnienieMaterialowBezLogowania': ' (Formularz online)'
        }
        options.forEach(e => e.label += ESERVICE_DETAILS[e.value] || '')
        this.setState({ districts_options: urzedy, services_options: options }, () =>
          this.fetch_info_page(),
    );
      });

    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
      display: 'block',
      minHeight: '80vh',
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
        display: 'block',
        minHeight: '80vh',
      };
    }
    this.setState({ colors, sourceStyle, style });

    const paymentMethodsUrl = `${process.env.API_URL}/eservices/getDistrictPaymentMethods`;
    fetch(paymentMethodsUrl)
      .then(r => r.json())
      .then(resp => {
        this.setState({ paymentMethods: resp });
      });
  }

  fetch_info_page = () => {
    let filtr = '';
    if (this.state.date) filtr += `&date=${this.state.date}&operator=${this.state.operator}`;
    if (this.state.status) filtr += `&status=${this.state.status}`;
    if (this.state.paymentStatus) filtr += `&paymentStatus=${this.state.paymentStatus}`;
    if (this.state.selected_districts.length) {
      filtr += `&teryt=[${this.state.selected_districts.reduce((prev, cur, i) => {
        if (i !== 0) {
          return `${prev}, ${cur.value}`;
        }
        return prev + cur.value;
      }, '')}]`;
    }
    if (this.state.selected_services.length) {
      filtr += `&services=[${this.state.selected_services.reduce((prev, cur, i) => {
        if (i !== 0) {
          return `${prev}, ${cur.value}`;
        }
        return prev + cur.value;
      }, '')}]`;
    }
    if (this.state.searchText) filtr += `&searchText=${this.state.searchText}`;

    filtr += `&ordering=${this.state.orderingOption}`;

    let url = `${process.env.API_URL}/user/documents/${
      this.props.userData.ID
    }?expanded=1&per_page=${this.state.per_page}&page=${this.state.page}`;
    if (filtr) url += filtr;
    return fetch(url)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          ...resp,
          fetchingInfoPage: false
        });
      });
  };

  terytToName = nrTeryt => {
    let name;
    for (const i of this.props.districts) {
      if (name !== undefined) {
        break;
      }
      if (i.teryt === nrTeryt) {
        name = i.name;
        break;
      }
    }
    return name;
  };

  getDateFromString = date => {
    let textDate = 'brak informacji';
    if (date) {
      const asDate = new Date(date);
      let day = asDate.getDate();
      if (day < 10) {
        day = `0${asDate.getDate()}`;
      }
      let month = asDate.getMonth() + 1;
      if (month < 10) {
        month = `0${asDate.getMonth() + 1}`;
      }
      textDate = `${day}.${month}.${asDate.getFullYear()}`;
    }
    return textDate;
  };

  logChange = e =>
    this.setState({
      page: 1,
      selected_services: e
    }, () => this.fetch_info_page());
  orderingChange = (e) =>
    this.setState({
      orderingOption: e.value,
      page: 1
    }, () => this.fetch_info_page());

  logChangeDistrict = e =>
    this.setState({
      page: 1,
      selected_districts: e
    }, () => this.fetch_info_page());
  handleChange = newDate =>
    this.setState({ date: newDate }, () => {
      if (this.state.operator && this.state.date) {
        this.setState({ page: 1 }, () => this.fetch_info_page());
      }
    });

  handleInputSearchText = ev => {
    const self = this;
    self.setState({fetchingInfoPage: true});
    if (self.state.fetchInfoPageTimeout) {
      clearTimeout(self.state.fetchInfoPageTimeout);
    }
    self.setState({
      searchText: ev.target.value,
      page: 1,
      fetchInfoPageTimeout: setTimeout(self.fetch_info_page, 1000)
    });
  }

  applyButton = page => this.setState({ apply_button_disabled: true, docs_page_counter: this.state.per_page }, () => this.setPage(page));

  setPage = page => {
    const self = this;
    self.setState({fetchingInfoPage: true}, () => {
      document.querySelector('#results').scrollIntoView();
    });
    if (self.state.fetchInfoPageTimeout) {
      clearTimeout(self.state.fetchInfoPageTimeout);
    }
    self.setState({
      page: page,
      fetchInfoPageTimeout: setTimeout(self.fetch_info_page, 1000)
    });
  }

  changeOperator = e =>
    this.setState({ operator: e.target.value }, () => {
      if (this.state.operator && this.state.date) {
        this.setState({ page: 1 }, () => this.fetch_info_page());
      }
    });
  changeStatus = e =>
    this.setState({
      page: 1,
      status: e.target.value
    }, () => this.fetch_info_page());
  changePaymentStatus = e =>
    this.setState({
      page: 1,
      paymentStatus: e.target.value
    }, () => this.fetch_info_page());

  cancelClaim = (claimId) => {
    fetch(`${process.env.API_URL}/cancelPZGiKClaim/${claimId}/`)
    .then(r => r.ok && window.location.reload())
  }

  selectDocumentsToDownload = (event, data) => {
    const selected = [...event.target.parentElement.querySelectorAll('input:checked')]
      .map(e => e.value);
    if (!selected.length) {
      return;
    }
    let docs = (selected.includes('__all__')) ? '' : `&docs=${selected.join(',')}`;
    this.setState({
      documentsDownloadLink: `${process.env.API_URL}/eservices/getJobDocs/${data.jobId}?v=${Date.now()}${docs}`
    }, () => document.querySelector('#download-docs-submit').click());
  }

  allowedAfterPayment = (status) => {
    return ['niewymagana', 'opłacono'].includes(
      Object.assign(Object.assign({}, MAP_CLAIM_STATUS), {
        'anulowany przez wnioskodawcę': 'anulowany',
        'anulowany, brak uprawnień': 'anulowany',
      })[status]
    );
  }

  renderCol = (v, i, data) => {
    if (data.pzgik.length == 0) {return null}
    const buttonStyle = {
      padding: '2px 2px',
      marginLeft: '0px',
      color: layoutColorStyle[this.state.colors].color,
      backgroundColor: layoutColorStyle[this.state.colors].backgroundColor,
      width: '100%',
    };
    if (v === 'shortName') {
      const service = this.props.eservices ? this.props.eservices[data[v]] : null;
      return service ? (
        <td key={`${v}${i}`}>
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="tooltip">
                <strong>Kliknij aby przejść do podsumowania</strong>
              </Tooltip>
            }
          >
            <Link to={`/paymentStatus/${data.jobId}`}>{service.title}</Link>
            {/* <a href="#">{service.title}</a> */}
          </OverlayTrigger>
        </td>
      ) : (
        <td key={`${v}${i}`}>{data[v]}</td>
      );
    }
    if (v === 'idWniosku') {
      return <td key={i}>{data.pzgik.length > 0 ? data.pzgik[0].idWniosku : ''}</td>
    }
    if (v === 'wysokoscOplaty') {
      return <td key={i}>{data.pzgik.length > 0
        ? (`${this.roundNumbers(this.roundNumbers((data.pzgik[0].wysokoscOplaty + data.pzgik[0].wysOplatyPrzesylka + data.pzgik[0].WysOplatyNosnik), 2), 1).toFixed(2)
            } zł${
            data.pzgik[0].pzgik_claim_details.length > 0
            && [
              'Wysyłka pod wskazany adres',
              'Wysyłka pod wskazany adres - własny nośnik',
            ].includes(data.pzgik[0].pzgik_claim_details[0].formaPrzekaz)
            && MAP_CLAIM_STATUS[data.pzgik[0].status] === 'obliczanie opłaty'
            ? ' (bez kosztów wysyłki pocztowej)'
            : ''}`)
        : '―'}</td>;
    }
    if (v === 'isSigned') {
      return <td key={`${v}${i}`}>{data[v] ? 'TAK' : 'NIE'}</td>;
    }
    if (v === 'timeStart') {
      return <td key={i}>{this.getDateFromString(data[v])}</td>;
    }
    if (v === 'timeEnd') {
      return <td key={i}>{this.getDateFromString(data[v])}</td>;
    }
    if (v === 'status') {
      return <td key={`${v}${i}`}>{
        data.pzgik.length > 0
        ? data.pzgik[0].status
        : ''
      }</td>;
    }
    if (v === 'paymentStatus') {
      if (data.pzgik.length > 0 && this.isPayablePurposePzgik(data.pzgik[0].celPobrMat)) {
        const paymentStatus = MAP_CLAIM_STATUS[data.pzgik[0].status];
        if (paymentStatus == 'do opłacenia' && data.pzgik[0].pzgik_claim_details[0].sposobPlatnosc == 'Płatność elektroniczna') {
          let redirectURL = `${process.env.API_URL}/eservices/jobPayment/${
            data.jobId
            }?deliveryMethod=${data.deliveryMethod}`;
          redirectURL += `&paymentMethod=${data.paymentMethod}`;
          if (data.epuapAddress) {
            redirectURL += `&epuapAddress=${data.epuapAddress}`;
          }
          redirectURL += `&bankAccountId=${data.bankAccountId}`;
          return <td key={`${v}${i}`}><a type="submit-lg" className="btn btn-default" href={redirectURL} style={buttonStyle}>Zapłać</a></td>;
        }
        return <td key={`${v}${i}`}>{paymentStatus}</td>;
      }
      return <td key={`${v}${i}`}>niewymagana</td>;
    }
    if (v === 'paymentMethod'){
    return <td key={i}>{
      data.pzgik.length > 0
      ? data.pzgik[0].pzgik_claim_details.length > 0
        ? [data.pzgik[0].pzgik_claim_details[0].sposobPlatnosc,
          data.pzgik[0].pzgik_claim_details[0].sposobPlatnosc === 'Przelewem'
          ? <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="tooltip" style={{backgroundColor: '#ccc'}}>
                  <span>
                    Dane do przelewu dostępne w DOO<br />
                    pod przyciskiem<br />
                    <b>Pobierz dokumenty &rarr;</b>
                  </span>
                </Tooltip>
              }
            ><i className={`glyphicon glyphicon-info-sign ${s.paymentInfo}`}></i>
            </OverlayTrigger>
          : '']
        : ''
      : ''
    }</td>;
    }
    if (v === 'deliveryMethod'){
      return <td key={i}>{
        data.pzgik.length > 0
        ? data.pzgik[0].pzgik_claim_details.length > 0
          ? data.pzgik[0].pzgik_claim_details[0].formaPrzekaz
          : ''
        : ''
        }</td>;
    }
    if (v === 'teryt') {
      const district = _.find(
        this.props.districts,
        dist => dist.teryt.toString() === data[v],
      );
      if (district) {
        return <td key={`${v}${i}`}>{this.props.districts[district.prefix].name}</td>;
      }
      return <td key={`${v}${i}`}>{data[v]}</td>;
    }
    if (v === 'parcels') {
      return <td key={`${v}${i}`}>{data[v].length}</td>;
    }
    if (v === 'docCount') {
      return <td key={`${v}${i}`}>{data.documents.length}</td>;
    }
    if (v === 'actions') {
      let sliderButton = <Button className={s.downloadDocsSlider}
          onClick={ev => {
            ev.currentTarget.nextElementSibling.classList.toggle('hidden');
            ev.currentTarget.querySelector('i.glyphicon').classList.toggle('glyphicon-triangle-bottom');
            ev.currentTarget.querySelector('i.glyphicon').classList.toggle('glyphicon-triangle-top');
          }}>
          Pobierz dokumenty <i className="glyphicon glyphicon-triangle-bottom"></i>
        </Button>
      let selectedDocuments = <fieldset className={`${s.downloadDocs} hidden`}>
          <label>
            <input type="checkbox" name="download-docs" value="__all__" title="Komplet dokumentów powiązanych z wnioskiem" onChange={
              ev => [...ev.currentTarget.parentElement.parentElement.querySelectorAll('input:not(:disabled)')].slice(1)
              .forEach(e => e.checked = ev.currentTarget.checked)
            } /> Wszystkie dokumenty
          </label><br />
          <label>
            <input type="checkbox" name="download-docs" value="wniosek" title="Wniosek w formacie docx i xml" defaultChecked /> Wniosek
          </label><br />
          <label>
            <input type="checkbox" name="download-docs" value="doo" title="Dokument obliczenia opłaty"
              disabled={!(this.allowedAfterPayment(data.pzgik[0].status)
                || data.pzgik[0].status === 'do opłacenia'
                ) || freeSharingReasonOptions.map(e => e.value).includes(data.pzgik[0].celPobrMat)
              } /> DOO
          </label><br />
          <label>
            <input type="checkbox" name="download-docs" value="klauzula" title="Klauzula"
              disabled={!this.allowedAfterPayment(data.pzgik[0].status)} /> Klauzula
          </label><br />
          <label>
            <input type="checkbox" name="download-docs" value="licencja" title="Licencja"
              disabled={!this.allowedAfterPayment(data.pzgik[0].status)} /> Licencja
          </label><br />
          <Button onClick={ev => this.selectDocumentsToDownload(ev, data)} >Pobierz</Button>
        </fieldset>;
      let cancelButton = (data.pzgik.length > 0
        && [
          'obliczanie opłaty za wysyłkę',
          'weryfikacja uprawnień',
          'do opłacenia'
        ].includes(data.pzgik[0].status))
        ? <a type="submit-lg" className="btn btn-default" onClick={ev =>
            this.setState({cancelClaimModal: {show: true, claimId: data.pzgik[0].ID}})
          } style={Object.assign({marginTop: '5px'}, buttonStyle)}>Anuluj wniosek</a>
        : null;
      return <td key={`${v}${i}`}>{sliderButton}{selectedDocuments}{cancelButton}</td>;
    }
  };

  toogleClaimDetails = (i, ev) => {
    const container = document.querySelector(`#claim-details-container-${i}`);
    const arrow = document.querySelector(`#claim-details-arrow-${i}`);
    container && container.classList.toggle('hidden', !container.classList.contains('hidden'));
    arrow && arrow.classList.toggle('glyphicon-triangle-bottom');
  }

  isPayablePurposePzgik = (purpose) => {
    const payablePurposes = ["dla dowolnych potrzeb", "dla potrzeb własnych niezwiązanych z działalnością gospodarczą, bez prawa publikacji w sieci Internet"]
    return payablePurposes.includes(purpose)
  }

  getNumberOfDays= (date) => {
    if (date) {
      const today = new Date();
      const dateEnd = new Date(date);

      // One day in milliseconds
      const oneDay = 1000 * 60 * 60 * 24;

      // Calculating the time difference between two dates
      const diffInTime = today.getTime() - dateEnd.getTime();

      // Calculating the no. of days between two dates
      const diffInDays = Math.round(diffInTime / oneDay);

      return diffInDays;
    }
    return 0;
  }

  renderRow = (v, i) => {
    if (v.pzgik.length == 0) {
      return null;
    }
    const number = i + 1 + (this.state.docs_page_counter * (this.state.page - 1));
    return (
      <tbody key={i}>
        <tr key={i}>
          <td rowSpan="2">{number}</td>
          {this.state.visible_columns.map((col, col_index) => this.renderCol(col, col_index, v))}
        </tr>
        <tr>
          <td colSpan={this.state.visible_columns.length}>
            <div>
              <span onClick={(ev) => this.toogleClaimDetails(i+1, ev)} className={s.claimDetailsHeader}>
                <i id={`claim-details-arrow-${i+1}`} className="glyphicon glyphicon-triangle-right" style={{fontSize: 'x-small'}}></i><strong>
                  Zamówione materiały:
                </strong>
              </span>
              <div id={`claim-details-container-${i+1}`} className="hidden">
                {(['zrealizowano', 'opłacono, przygotowano'].includes(v.pzgik[0].status) && [
                  'Udostępnienie na serwerze FTP WODGiK',
                  'Wysyłka na wskazany adres e-mail'].includes(v.pzgik[0].pzgik_claim_details[0].formaPrzekaz) &&
                  this.getNumberOfDays(v.pzgik[0].dataUdostepnieniaMat) < 30) ?
                    <p style={{ color: 'red' }}>
                      UWAGA! Po 30 dniach od daty zrealizowania wniosku, materiał zostanie usunięty z serwera i nie będzie można go pobrać.
                    </p> : null}
                {(['zrealizowano', 'opłacono, przygotowano'].includes(v.pzgik[0].status) && [
                  'Udostępnienie na serwerze FTP WODGiK',
                  'Wysyłka na wskazany adres e-mail'].includes(v.pzgik[0].pzgik_claim_details[0].formaPrzekaz) &&
                  this.getNumberOfDays(v.pzgik[0].dataUdostepnieniaMat) >= 30) ?
                    <p style={{ color: 'red' }}>
                      UWAGA! Minęło 30 dni od daty zrealizowania wniosku. Materiał został usunięty z serwera i nie można go pobrać.
                    </p> : null}

                <p>{this.getNumberOfDays(v.pzgik[0].dataUdostepnieniaMat)}</p>
                <table className={s.claimDetailsBody + ' table'}>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Przedmiot wniosku</th>
                      {
                        v.pzgik.length > 0
                        && v.pzgik[0].pzgik_claim_details.filter(
                          e => e.formaMat == 'drukowana').length
                        ? <th>Liczba egzemplarzy</th>
                        : <th></th>
                      }
                      <th>Format danych</th>
                      <th></th>
                    </tr>
                  </thead>
                  {
                    v.pzgik.map(pzgikClaim =>
                      pzgikClaim.pzgik_claim_details.map((pzgikClaimDetail, j) => (
                        <tbody>
                          <tr key={j}>
                            <td rowSpan="2">{j + 1}</td>
                            <td>{pzgikClaimDetail.przedmiotWnioskuPoj}</td>
                            {
                              pzgikClaimDetail.formaMat === 'drukowana'
                              ? <td>{pzgikClaimDetail.iloscDanych}</td>
                              : <td />
                            }
                            <td>{pzgikClaimDetail.formaMat}</td>
                            {
                              (j === 0 && [
                                'Udostępnienie na serwerze FTP WODGiK',
                                'Wysyłka na wskazany adres e-mail',
                              ].includes(pzgikClaim.pzgik_claim_details[0].formaPrzekaz)
                              && [
                                'opłacono, przygotowano',
                                'bezpłatny, przygotowano',
                                'wysłano pocztą tradycyjną',
                                'zrealizowano',
                              ].includes(pzgikClaim.status)
                              && this.getNumberOfDays(v.pzgik[0].dataUdostepnieniaMat) < 30
                              )
                              ? <td style={{ textAlign: 'right' }}>
                                <a
                                  className="btn btn-default"
                                  href={`${process.env.FTP_URL}/s/${pzgikClaim.shareLink}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                    Pobierz materiały
                                  </a>
                              </td>
                              : <td />
                            }
                          </tr>
                          <tr>
                            <td colSpan="4">
                              <table className="table table-hover">
                                <thead>
                                  <tr>
                                    <th>Wybrane obszary</th>
                                    {
                                      pzgikClaimDetail.formaMat == 'drukowana'
                                      ? <th>Liczba egzemplarzy</th>
                                      : <th></th>
                                    }
                                    <th>Format danych</th>
                                    {
                                      <th>Opłata za materiał</th>
                                    }
                                  </tr>
                                </thead>
                                <tbody>
                                  {
                                    pzgikClaimDetail.locations.map((location, j) => (
                                      <tr style={{color: '#777'}} key={j}>
                                        <td>{location.godlo}</td>
                                        {
                                          pzgikClaimDetail.formaMat == 'drukowana'
                                          ? <td>{location.liczbaEgzemplarzy}</td>
                                          : <td></td>
                                        }
                                        <td>{pzgikClaimDetail.formaMat}</td>
                                        {
                                          this.isPayablePurposePzgik(pzgikClaim.celPobrMat)
                                          ? <td>{(pzgikClaimDetail.wysokoscOplatyPoj/pzgikClaimDetail.iloscDanych).toFixed(2)} zł</td>
                                          : <td>materiał udostępniany bezpłatnie</td>
                                        }
                                      </tr>
                                    ))
                                  }
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      )).concat([
                      pzgikClaim.wysOplatyPrzesylka
                        ? <tbody><tr><td colSpan="4">Koszt wysyłki pocztowej: {pzgikClaim.wysOplatyPrzesylka.toFixed(2)} zł</td></tr></tbody>
                        : null
                      ]).concat([
                        pzgikClaim.WysOplatyNosnik
                        ? <tbody><tr><td colSpan="4">Opłata za nośnik: {pzgikClaim.WysOplatyNosnik.toFixed(2)} zł</td></tr></tbody>
                        : null
                      ])
                    )
                  }
                  </table>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    );
  };

  roundNumbers = (num, digits) => {
    const multiplier = Math.pow(10, digits || 0);
    return Math.round(num * multiplier) / multiplier;
  }

  renderPagination = () => {
    const pageCount = this.state.pages.pages;
    const current = this.state.page;

    let start = 1;
    let end = pageCount;
    const diff = 5;

    if (pageCount >= 2 * diff) {
      if (current + diff >= pageCount) {
        start = pageCount - 2 * diff + 1;
        end += 1;
      }
      if (current >= diff && current + diff <= pageCount) {
        start = current - diff + 1;
        end = current + diff;
      }
      if (current < diff) {
        start = 1;
        end = 1 + 2 * diff;
      }
    } else {
      end = pageCount + 1;
    }
    if (start === 1 && end === 1) end += 1;

    return (
      <Pagination>
        <Pagination.First
          disabled={this.state.page === 1}
          onClick={() => this.setPage(1)}
        />
        <Pagination.Prev
          disabled={this.state.page === 1}
          onClick={() => this.state.page !== 1 ? this.setPage(this.state.page - 1) : null}
        />
        {_.range(start, end).map((v, i) => (
          <Pagination.Item key={i} onClick={() => this.setPage(v)} active={v === this.state.page}>
            {v}
          </Pagination.Item>
        ))}
        <Pagination.Next
          disabled={this.state.page === pageCount}
          onClick={() => this.state.page !== pageCount ? this.setPage(this.state.page + 1) : null}
        />
        <Pagination.Last
          disabled={this.state.page === pageCount}
          onClick={() => this.setPage(pageCount)}
        />
      </Pagination>
    );
  };

  render() {
    return this.state.pages ? (
      <div className={s.mdContainer} style={this.state.style}>
        <Row>
          <Col xs={12}>
              <h3 className={s.delTitle}>Zamówione materiały</h3>
          </Col>
        </Row>
        <Row>
          <Col xsOffset={9} xs={3}>
            <Button style={{width: '100%'}} onClick={() => this.setState({
                filtersCollapse: !this.state.filtersCollapse
            })}>{
              this.state.filtersLabels.find((e, i) => i == this.state.filtersCollapse)
            }</Button>
          </Col>
        </Row>
        <Collapse in={this.state.filtersCollapse}>
          <div>
          <Row>
            <Col xs={2}>
              <h4>Wyszukiwany tekst</h4>
            </Col>
            <Col xs={7} style={{ color: 'black' }}>
              <input
                type="text"
                onChange={this.handleInputSearchText}
                value={this.state.searchText}
                style={{width: '100%'}}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={2}>
              <h4>Data wygenerowania</h4>
            </Col>
            <Col xs={1}>
              <select
                className="form-control"
                style={{ width: 'auto' }}
                value={this.state.operator}
                onChange={this.changeOperator}
              >
                {Object.keys(operator_map).map((v, i) => (
                  <option key={i} value={operator_map[v]}>
                    {v}
                  </option>
                ))}
              </select>
            </Col>
            <Col xs={3} style={{ color: 'black' }}>
              <DatePicker
                onChange={this.handleChange}
                value={this.state.date}
                placeholder="DD-MM-YYYY"
                monthLabels={polishMonthLabels}
                dayLabels={polishDayLabels}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={2}>
              <h4>Status</h4>
            </Col>
            <Col xs={3}>
              <select className="form-control" value={this.state.status} onChange={this.changeStatus}>
                <option />
                {
                  Object.keys(MAP_CLAIM_STATUS).map(e => <option>{e}</option>)
                }
              </select>
            </Col>
          </Row>
          <Row>
            <Col xs={2}>
              <h4>Status płatności</h4>
            </Col>
            <Col xs={3}>
              <select
                className="form-control"
                value={this.state.paymentStatus}
                onChange={this.changePaymentStatus}
              >
                <option />
                {
                  Object.values(MAP_CLAIM_STATUS)
                  .filter((e, i, a) => a.indexOf(e) === i)
                  .map(e => <option>{e}</option>)
                }
              </select>
            </Col>
          </Row>
          {/* <Row>
            <Col xs={4}>
              <h4>Jednostka Administracyjna</h4>
            </Col>
            <Col xs={8}>
              <Select
                placeholder="Wybierz gminę"
                multi
                rows={40}
                name="form-field-name"
                value={this.state.selected_districts}
                options={this.state.districts_options}
                clearable={false}
                onChange={this.logChangeDistrict}
              />
            </Col>
          </Row> */}
          <Row>
            <Col xs={2}>
              <h4>Usługi</h4>
            </Col>
            <Col xs={7}>
              <Select
                placeholder="Wybierz usługi"
                multi
                rows={40}
                name="form-field-name"
                value={this.state.selected_services}
                options={this.state.services_options}
                clearable={false}
                onChange={this.logChange}
              />
            </Col>
          </Row>
          </div>
        </Collapse>
        <Row>
          <Col xsOffset={9} xs={3}>
            <Button style={{width: '100%'}} onClick={() => this.setState({
                orderingCollapse: !this.state.orderingCollapse
            })}>{
              this.state.orderingLabels.find((e, i) => i == this.state.orderingCollapse)
            }</Button>
          </Col>
        </Row>
        <Collapse in={this.state.orderingCollapse}>
          <Col xs={3}>
            <Select
              placeholder="Sortuj według..."
              name="form-field-name"
              editable="false"
              value={this.state.orderingOption}
              options={orderingOptions}
              onChange={this.orderingChange}
            />
          </Col>
        </Collapse>

        {this.state.user_claims ? (
          <Row style={{ marginTop: '20px' }}>
            <Col xs={12}>
              <Table condensed id="results">
                <thead>
                  <tr>
                    <th>#</th>
                    {this.state.visible_columns.map((v, i) => {
                      if (v !== 'actions') return <th key={i}>{col_header_map[v]}</th>;
                      if (
                        v === 'actions' &&
                        this.props.userData &&
                        this.props.userData.roles &&
                        this.props.userData.roles.indexOf('superadmin') > -1
                      ) {
                        return <th key={i}>{col_header_map[v]}</th>;
                      }
                    })}
                  </tr>
                </thead>
                {this.state.fetchingInfoPage
                  ? <tbody>
                      <tr>
                        <td colSpan={this.state.visible_columns.length}
                          style={{ textAlign: 'center' }}>
                          <img role="presentation" src={waiting}
                            style={{ margin: 'auto' }}/>
                        </td>
                      </tr>
                    </tbody>
                  : this.state.user_claims.map((v, i) => this.renderRow(v, i))
                }
              </Table>
            </Col>
          </Row>
        ) : null}
        {this.state.pages ? (
          <Row style={{ textAlign: 'center' }}>
            <Col xs={1} style={{ marginTop: '20px' }}>
              <span>Na stronie: </span>
            </Col>
            <Col xs={1} style={{ marginTop: '20px' }}>
              <input
                className="form-control"
                value={this.state.per_page}
                onChange={e =>
                  this.setState({ per_page: e.target.value, apply_button_disabled: false })
                }
              />
            </Col>
            <Col xs={1} style={{ marginTop: '20px' }}>
              <button
                type="submit-lg"
                className="btn btn-default"
                disabled={this.state.apply_button_disabled}
                style={{ float: 'right', marginRight: '15px' }}
                onClick={() => this.applyButton(1)}
              >
                Zastosuj
              </button>
            </Col>
            <Col xs={8}>{this.renderPagination()}</Col>
            <Col xs={1} style={{ marginTop: '20px' }}>
              <div>
                {this.state.page}/{this.state.pages.pages}
              </div>
            </Col>
          </Row>
        ) : null}

        <Modal show={this.state.cancelClaimModal.show} onHide={() =>
          this.setState({cancelClaimModal: {show: false, claimId: null}})}>
          <Modal.Header className="bg-warning" closeButton>
            <Modal.Title>Anulowanie wniosku</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Czy na pewno anulować wniosek?
            <br /><br />
            <Button className="btn btn-warning pull-right" onClick={ev =>
              this.cancelClaim(this.state.cancelClaimModal.claimId)}>TAK</Button>
            <Button className="btn btn-default pull-right" onClick={ev =>
              this.setState({cancelClaimModal: {show: false, claimId: null}})
            }>NIE</Button>
            <br /><br />
          </Modal.Body>
        </Modal>

        <a href={this.state.documentsDownloadLink} id="download-docs-submit" className='hidden' download target="_blank"></a>
      </div>
    ) : (
      <GrayPanel
        bodyStyle={{ textAlign: 'center !important', marginTop: '100px', marginBottom: '100px' }}
      >
        <img role="presentation" src={waiting} />
      </GrayPanel>
    );
  }
}

const mapState = state => ({
  username: state.user ? state.user.username : '',
  districts: state.district.districts,
  eservices: state.eservices.eservices
});

export default withStyles(s)(connect(mapState)(MojeDokumenty));



// WEBPACK FOOTER //
// src/routes/mojeDokumenty/MojeDokumenty.js